<div class="animated fadeIn m-n5">
  <div class="row g-0">
        <div class="image-container">
          <img class="card-img-top" src="https://fitritestagingstorage.blob.core.windows.net/fitrite365/websitecontent/background img2.jpeg" alt="settees">
          <div class="overlay">
            <div class="row mt-3 float-end">
              <img id="trustimg" class="me-5 mt-1"
                   src="https://fitrite.info/wp-content/themes/fitrite2025/assets/imgs/logos/Fitrite-Logo.png" alt="">
            </div>
            <div class="row ms-5 pt-5 ps-5 mt-5 text-white h1 font-la">
              Wish To Contact Us?
            </div>
            <div class="row ms-5 ps-5 mt-5 text-white">
              <a href="mailto:info@fitrite.info" class="h3"><i class="fa-regular fa-envelope"></i> Email: info&#64;fitrite.info</a>
            </div>
            <div class="row ms-5 ps-5 mt-5 text-white">
              <p class="h3"><i class="fa-solid fa-phone"></i> Telephone: 0123456789</p>
            </div>
            <div class="row ms-5 ps-5 mt-5 text-white">
              <p class="h3"><i class="fa-solid fa-house"></i> Where Are We Based?</p>
              <p class="ps-5">Fitrite Fencing & Decking Ltd,</p>
              <p class="ps-5">Unit F Parkside Business Park,</p>
              <p class="ps-5">Spinners Rd,</p>
              <p class="ps-5">Doncaster DN2 4BL</p>
            </div>
          </div>
        </div>
  </div>
</div>

